import { ProjectTreeNodeT } from "components/project/layers/hooks";
import {
  useProjectContext,
  useProjectDispatch
} from "components/project/projects/context";

import { StructuredNodeProvider, initialStructuredNodeState } from ".";

type NodeProviderWithManagerPropsT = {
  node: ProjectTreeNodeT;
  children: React.ReactNode;
  isSelectable?: boolean;
};
export function NodeProviderWithManager(
  props: NodeProviderWithManagerPropsT
): JSX.Element {
  const { node, children, isSelectable = false } = props;

  const { newlyCreatedFolderId } = useProjectContext();
  const projectDispatch = useProjectDispatch();

  const initialState = {
    ...initialStructuredNodeState,
    inEditMode: node.key === newlyCreatedFolderId,
    isNewlyCreatedFolder: node.key === newlyCreatedFolderId,
    editableTitle: node.title,
    originalTitle: node.title
  };

  if (node.key === newlyCreatedFolderId) {
    projectDispatch({
      payload: { newlyCreatedFolderId: null }
    });
  }

  return (
    <StructuredNodeProvider initialState={initialState}>
      <div onClick={isSelectable ? undefined : (e) => e.stopPropagation()}>
        {children}
      </div>
    </StructuredNodeProvider>
  );
}
